import { useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import Header from '../../../../components/Header';
import CustomAlertModel from '../../../components/customAlertModel';
import CustomDrawer from '../../../components/customDrawer';
import UsePaymentReceivedDetails from '../hooks/usePaymentReceivedDetails';
import PaymentReceivedPdfView from './paymentReceivedPdfView';
import Button from '../../../../../component/ui/Button';
import { toast } from 'react-toastify';
import { adjustRefundAmount } from '../../../../../services/payments_received';
import CustomSalesDrawer from '../../../components/customSalesDrawer';
import PaymentReceivedTabs from './paymentReceivedTabs';
import { getDate } from '../../../../../utils/dateUtils';
import Modal from '../../../../../component/modal/Modal';
import { hasPermission } from '../../../../../utils/controller';

const PaymentReceivedDetails = () => {
	const {
		user,
		prDetails,
		navigate,
		suburl,
		id,
		loading,
		setIsDeletePaymentReceivedModalOpen,
		isDeletePaymentReceivedModalOpen,
		handleDeletePaymentReceived,
		generateSalesPaymentReceivedPdf,
		getPaymentReceivedDetails,
	} = UsePaymentReceivedDetails();
	const [drawerType, setDrawerType] = useState('');
	const [invoiceId, setInvoiceId] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isSalesDrawerOpen, setIsSalesDrawerOpen] = useState(false);
	const [isOpenModelForPR, setIsOpenModelForPR] = useState(false);
	const [isRefundAmountLoading, setIsRefundAmountLoading] = useState(false);

	async function settleRefundAmount(value) {
		try {
			setIsRefundAmountLoading(true);
			var body = {
				payment_receive_id: id,
				isRefund_amount: value,
			};
			await adjustRefundAmount(body);
			toast.success('Adjust refund amount successfully');
			getPaymentReceivedDetails();
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		} finally {
			setIsRefundAmountLoading(false);
		}
	}

	return (
		<div style={{ backgroundColor: '#EDEDF7', height: '100%', overflowY: 'auto' }}>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 30,
					backgroundColor: '#EDEDF7',
					boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				}}
			>
				<Header
					headerTitle="Payment Received Details"
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(`/user/${suburl}/payments-received`),
					}}
					buttons={[
						prDetails &&
							prDetails?.sales_credit_notes_excess_payments?.length < 1 && {
								className: 'btn-gray mt-0 px-4 ',
								button: 'Edit',
								disabled: true,
								handler: () => navigate(`/user/${suburl}/payments-received-create/${id}`),
							},
						prDetails && {
							className: 'btn-gray mt-0 px-4 ',
							button: 'Send Email',
							disabled: !hasPermission(
								'sales.payments_received.communications_email',
								user?.role?.role_permissions,
							),
							handler: () => navigate(`/user/${suburl}/payments-received-send-emails/${id}`),
						},
						prDetails && {
							className: 'btn-gray mt-0 px-4 ',
							button: 'PDF/Print',
							handler: () => generateSalesPaymentReceivedPdf('print', false),
						},
						{
							className: 'btn-gray mt-0 px-4 ',
							button: 'Delete',
							disabled: !hasPermission(
								'sales.payments_received.delete',
								user?.role?.role_permissions,
							),
							handler: () => {
								if (prDetails?.sales_credit_notes_excess_payments?.length > 0) {
									setIsOpenModelForPR(true);
								} else {
									setIsDeletePaymentReceivedModalOpen(true);
								}
							},
						},
					]}
				/>
				<PaymentReceivedTabs
					creditNoteList={
						prDetails?.sales_credit_notes_excess_payments?.length > 0
							? prDetails?.sales_credit_notes_excess_payments?.map((ele) => {
									return {
										id: ele.credit_note_id,
										DATE: getDate(ele?.credit_note?.date),
										'CREDIT NOTE #': ele?.credit_note?.credit_note_number || 'N/A',
										'CUSTOMER NAME': prDetails.customer?.name || 'N/A',
										STATUS: ele?.credit_note?.status,
										TYPE:
											ele?.credit_note?.credit_note_type === 1
												? 'Damaged/Return Goods'
												: ele?.credit_note?.credit_note_type === 2
													? 'Excess Payment'
													: 'Advance Payment',
										AMOUNT: Number(ele?.credit_note?.total_credit_amount).toFixed(2),
									};
								})
							: []
					}
				/>
				{prDetails && Number(prDetails.excess_payment_amount) > 0 && (
					<div
						style={{
							backgroundColor: '#FFC008',
							padding: '10px 0px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							borderTop: '1px solid #ccc',
						}}
					>
						<div
							style={{ color: '#000', fontSize: '14px', fontWeight: '600', marginRight: '10px' }}
						>
							Action Required: Excess/Unused amount pending. Adjusting this amount is required.
						</div>
						<Button
							type="button"
							className="mx-1 btn-primary add-pro"
							disabled={!hasPermission('sales.credit_note.create', user?.role?.role_permissions)}
							button="Create Credit Note"
							onClick={() => {
								if (isRefundAmountLoading === false) {
									settleRefundAmount(false);
								}
							}}
						/>
						<div className="mx-2"></div>
						<Button
							type="button"
							className="mt-0 btn-primary add-pro"
							button="Refund Amount"
							onClick={() => {
								if (isRefundAmountLoading === false) {
									settleRefundAmount(true);
								}
							}}
						/>
					</div>
				)}
			</div>
			{loading ? (
				<PageLoader />
			) : (
				<PaymentReceivedPdfView
					prDetails={prDetails}
					isRefundAmountLoading={isRefundAmountLoading}
					setDrawerType={setDrawerType}
					setInvoiceId={setInvoiceId}
					setIsDrawerOpen={setIsDrawerOpen}
					setIsSalesDrawerOpen={setIsSalesDrawerOpen}
					settleRefundAmount={settleRefundAmount}
				/>
			)}
			{isOpenModelForPR && (
				<Modal
					className="deleteVendorsModal"
					title="Payment Received Delete"
					isOpen={isOpenModelForPR}
					onClose={() => {
						setIsOpenModelForPR(false);
					}}
					cancelButton={() => {
						setIsOpenModelForPR(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						{'Please delete the associated record ' +
							prDetails?.sales_credit_notes_excess_payments[0]?.credit_note?.credit_note_number +
							' first before deleting this record.'}
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Cancel"
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModelForPR(false)}
						/>

						<Button
							type="button"
							button={
								'Go to Dependent Record (' +
								prDetails?.sales_credit_notes_excess_payments[0]?.credit_note?.credit_note_number +
								')'
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								navigate(
									`/user/${suburl}/sales/credit-note-details/${prDetails?.sales_credit_notes_excess_payments[0]?.credit_note?.id}`,
									{},
								);
							}}
						/>
					</div>
				</Modal>
			)}
			{isDeletePaymentReceivedModalOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsDeletePaymentReceivedModalOpen}
					isAlertModelOpen={isDeletePaymentReceivedModalOpen}
					customText={'Are you sure you want to delete payments received'}
					objectSelectedList={[]}
					title={'Payments Received Delete'}
					objectLength={''}
					handleBulk={handleDeletePaymentReceived}
				/>
			)}
			{
				<CustomSalesDrawer
					isOpen={isSalesDrawerOpen}
					onClose={() => setIsSalesDrawerOpen(false)}
					id={invoiceId}
					type={'Invoice'}
				/>
			}
			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? prDetails.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default PaymentReceivedDetails;
